import React from "react";

import { IClient } from "../../../../common/interfaces/IClient";

//styles
import cx from "classnames";

//components
import ClientChildrenBox from "../ClientBox/ChildrenClientBox";
import Icon from "../../../../common/components/Icon/Icon";
import Tooltip from "../../../../common/components/Tooltips/Tooltip";

const MAX_CHILDREN = 4;
interface IClientChildrenDetailsSection {
    clients: IClient[];
    onDelete: (index: number) => void;
    addChild: () => void;
}

const ClientChildrenDetailsSection: React.FC<IClientChildrenDetailsSection> = (props) => {
    const { clients, onDelete, addChild } = props;

    function canAddChild(clients: IClient[]): boolean {
        return clients.filter((i) => i.isChild).length < MAX_CHILDREN;
    }

    return (
        <div className="panel-card padding-2xl">
            <h3
                className={cx(
                    "title-build-client",
                    "layout-flex-row--centered",
                    "gap-m"
                )}>
                Children
                <Tooltip
                    className="space-pre-m"
                    tooltipContent="Children are under the age of 16."
                />
            </h3>

            {clients.map((client, index) => {
                if (client.isChild)
                    return (
                        <ClientChildrenBox
                            key={index}
                            onDelete={onDelete}
                            client={client}
                            index={index}
                            clients={clients}
                        />
                    );
            })}
            {canAddChild(clients) && (
                <button
                    className={cx(
                        "layout-flex-row--centered",
                        "text-brand",
                        "gap-pre-m",
                        "text-font-size-s",
                        "button-link"
                    )}
                    data-ga_category="build-step"
                    data-ga_action="family"
                    data-ga_label={"add-child"}
                    onClick={addChild}>
                    <Icon id="PersonIcon" className="space-s" />
                    Add another child
                </button>
            )}
        </div>
    );
};

export default ClientChildrenDetailsSection;
